module.exports = __webpack_public_path__ + "static/media/Invite-participants-popup-contest.1726a569.png";